const data = {
  title: "Floor 3-8",
  musicTrack: "MUSIC_WORLD3",
  theme: "PINK",
  tilesWidth: 13,
  tilesHeight: 13,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 7,
      y: 7
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 12,
      y: 2
    },
    {
      type: "ICE",
      x: 9,
      y: 2
    },
    {
      type: "ICE",
      x: 10,
      y: 2
    },
    {
      type: "ICE",
      x: 4,
      y: 3
    },
    {
      type: "ICE",
      x: 3,
      y: 5
    },
    {
      type: "ICE",
      x: 2,
      y: 6
    },
    {
      type: "ICE",
      x: 3,
      y: 6
    },
    {
      type: "ICE",
      x: 6,
      y: 3
    },
    {
      type: "ICE",
      x: 4,
      y: 5
    },
    {
      type: "ICE",
      x: 4,
      y: 4
    },
    {
      type: "ICE",
      x: 13,
      y: 1,
      corner: "TOP_RIGHT"
    },
    {
      type: "ICE",
      x: 8,
      y: 1
    },
    {
      type: "ICE",
      x: 7,
      y: 3
    },
    {
      type: "ICE",
      x: 7,
      y: 4
    },
    {
      type: "ICE",
      x: 10,
      y: 1
    },
    {
      type: "ICE",
      x: 13,
      y: 2
    },
    {
      type: "CHIP",
      x: 8,
      y: 1
    },
    {
      type: "ICE",
      x: 12,
      y: 3
    },
    {
      type: "ICE",
      x: 12,
      y: 4
    },
    {
      type: "ICE",
      x: 7,
      y: 5
    },
    {
      type: "CHIP",
      x: 6,
      y: 5
    },
    {
      type: "CHIP",
      x: 2,
      y: 7
    },
    {
      type: "ICE",
      x: 5,
      y: 7
    },
    {
      type: "ICE",
      x: 2,
      y: 7
    },
    {
      type: "ICE",
      x: 2,
      y: 8
    },
    {
      type: "ICE",
      x: 5,
      y: 3
    },
    {
      type: "ICE",
      x: 11,
      y: 3
    },
    {
      type: "ICE",
      x: 10,
      y: 3
    },
    {
      type: "ICE",
      x: 10,
      y: 4
    },
    {
      type: "ICE",
      x: 2,
      y: 9
    },
    {
      type: "ICE",
      x: 3,
      y: 9
    },
    {
      type: "ICE",
      x: 4,
      y: 9
    },
    {
      type: "ICE",
      x: 5,
      y: 9
    },
    {
      type: "ICE",
      x: 4,
      y: 10
    },
    {
      type: "ICE",
      x: 2,
      y: 11
    },
    {
      type: "ICE",
      x: 2,
      y: 12
    },
    {
      type: "ICE",
      x: 2,
      y: 13
    },
    {
      type: "ICE",
      x: 2,
      y: 10
    },
    {
      type: "ICE",
      x: 3,
      y: 12
    },
    {
      type: "ICE",
      x: 4,
      y: 11
    },
    {
      type: "ICE",
      x: 5,
      y: 11
    },
    {
      type: "ICE",
      x: 5,
      y: 12
    },
    {
      type: "ICE",
      x: 5,
      y: 13
    },
    {
      type: "ICE",
      x: 6,
      y: 12
    },
    {
      type: "ICE",
      x: 6,
      y: 13
    },
    {
      type: "ICE",
      x: 7,
      y: 11
    },
    {
      type: "ICE",
      x: 7,
      y: 12
    },
    {
      type: "ICE",
      x: 11,
      y: 12
    },
    {
      type: "ICE",
      x: 11,
      y: 11
    },
    {
      type: "ICE",
      x: 11,
      y: 13
    },
    {
      type: "ICE",
      x: 10,
      y: 10
    },
    {
      type: "ICE",
      x: 10,
      y: 11
    },
    {
      type: "ICE",
      x: 9,
      y: 13
    },
    {
      type: "ICE",
      x: 8,
      y: 13
    },
    {
      type: "ICE",
      x: 9,
      y: 12
    },
    {
      type: "ICE",
      x: 9,
      y: 11
    },
    {
      type: "ICE",
      x: 8,
      y: 9
    },
    {
      type: "ICE",
      x: 9,
      y: 9
    },
    {
      type: "ICE",
      x: 9,
      y: 7
    },
    {
      type: "ICE",
      x: 13,
      y: 5
    },
    {
      type: "ICE",
      x: 12,
      y: 6
    },
    {
      type: "ICE",
      x: 11,
      y: 8
    },
    {
      type: "ICE",
      x: 11,
      y: 9
    },
    {
      type: "ICE",
      x: 12,
      y: 10
    },
    {
      type: "ICE",
      x: 12,
      y: 9
    },
    {
      type: "ICE",
      x: 13,
      y: 10
    },
    {
      type: "ICE",
      x: 13,
      y: 8
    },
    {
      type: "ICE",
      x: 12,
      y: 8
    },
    {
      type: "ICE",
      x: 12,
      y: 7
    },
    {
      type: "ICE",
      x: 5,
      y: 8
    },
    {
      type: "ICE",
      x: 10,
      y: 13
    },
    {
      type: "ICE",
      x: 1,
      y: 13,
      corner: "BOTTOM_LEFT"
    },
    {
      type: "ICE",
      x: 13,
      y: 13,
      corner: "BOTTOM_RIGHT"
    },
    {
      type: "ICE",
      x: 1,
      y: 1,
      corner: "TOP_LEFT"
    },
    {
      type: "ICE",
      x: 3,
      y: 2
    },
    {
      type: "ICE",
      x: 1,
      y: 2
    },
    {
      type: "ICE",
      x: 2,
      y: 3
    },
    {
      type: "ICE",
      x: 3,
      y: 3
    },
    {
      type: "WATER",
      x: 12,
      y: 11
    },
    {
      type: "ICE",
      x: 13,
      y: 4
    },
    {
      type: "WATER",
      x: 9,
      y: 3
    },
    {
      type: "WATER",
      x: 12,
      y: 1
    },
    {
      type: "WATER",
      x: 13,
      y: 7
    },
    {
      type: "WATER",
      x: 8,
      y: 12
    },
    {
      type: "WATER",
      x: 10,
      y: 9
    },
    {
      type: "WATER",
      x: 4,
      y: 13
    },
    {
      type: "ICE",
      x: 4,
      y: 8
    },
    {
      type: "ICE",
      x: 3,
      y: 10
    },
    {
      type: "ICE",
      x: 1,
      y: 11
    },
    {
      type: "ICE",
      x: 1,
      y: 12
    },
    {
      type: "ICE",
      x: 6,
      y: 11
    },
    {
      type: "ICE",
      x: 6,
      y: 9
    },
    {
      type: "ICE",
      x: 7,
      y: 10
    },
    {
      type: "ICE",
      x: 8,
      y: 10
    },
    {
      type: "ICE",
      x: 8,
      y: 11
    },
    {
      type: "ICE",
      x: 7,
      y: 9
    },
    {
      type: "ICE",
      x: 5,
      y: 10
    },
    {
      type: "ICE",
      x: 9,
      y: 8
    },
    {
      type: "ICE",
      x: 11,
      y: 6
    },
    {
      type: "ICE",
      x: 11,
      y: 7
    },
    {
      type: "ICE",
      x: 12,
      y: 5
    },
    {
      type: "ICE",
      x: 13,
      y: 3
    },
    {
      type: "ICE",
      x: 11,
      y: 2
    },
    {
      type: "ICE",
      x: 9,
      y: 1
    },
    {
      type: "ICE",
      x: 7,
      y: 1
    },
    {
      type: "ICE",
      x: 7,
      y: 2
    },
    {
      type: "ICE",
      x: 6,
      y: 4
    },
    {
      type: "ICE",
      x: 6,
      y: 5
    },
    {
      type: "ICE",
      x: 5,
      y: 6
    },
    {
      type: "ICE",
      x: 5,
      y: 5
    },
    {
      type: "ICE",
      x: 3,
      y: 7
    },
    {
      type: "ICE",
      x: 8,
      y: 4
    },
    {
      type: "ICE",
      x: 3,
      y: 4
    },
    {
      type: "ICE",
      x: 4,
      y: 2
    },
    {
      type: "ICE",
      x: 5,
      y: 1
    },
    {
      type: "ICE",
      x: 1,
      y: 3
    },
    {
      type: "ICE",
      x: 1,
      y: 4
    },
    {
      type: "ICE",
      x: 1,
      y: 7
    },
    {
      type: "ICE",
      x: 11,
      y: 10
    },
    {
      type: "ICE",
      x: 13,
      y: 9
    },
    {
      type: "WATER",
      x: 6,
      y: 10
    },
    {
      type: "WATER",
      x: 3,
      y: 11
    },
    {
      type: "WATER",
      x: 4,
      y: 7
    },
    {
      type: "ICE",
      x: 8,
      y: 2
    },
    {
      type: "ICE",
      x: 2,
      y: 5
    },
    {
      type: "ICE",
      x: 3,
      y: 8
    },
    {
      type: "ICE",
      x: 1,
      y: 10
    },
    {
      type: "ICE",
      x: 13,
      y: 12
    },
    {
      type: "ICE",
      x: 11,
      y: 4
    },
    {
      type: "WALL",
      x: 2,
      y: 4
    },
    {
      type: "WALL",
      x: 8,
      y: 3
    },
    {
      type: "WALL",
      x: 11,
      y: 1
    },
    {
      type: "WALL",
      x: 4,
      y: 6
    },
    {
      type: "WALL",
      x: 10,
      y: 8
    },
    {
      type: "ICE",
      x: 10,
      y: 6
    },
    {
      type: "ICE",
      x: 10,
      y: 7
    },
    {
      type: "WALL",
      x: 9,
      y: 5
    },
    {
      type: "ICE",
      x: 12,
      y: 12
    },
    {
      type: "WALL",
      x: 4,
      y: 12
    },
    {
      type: "ICE",
      x: 2,
      y: 2
    },
    {
      type: "WALL",
      x: 3,
      y: 13
    },
    {
      type: "WALL",
      x: 9,
      y: 10
    },
    {
      type: "ICE",
      x: 7,
      y: 13
    },
    {
      type: "ICE",
      x: 13,
      y: 6
    },
    {
      type: "CHIP",
      x: 13,
      y: 6
    },
    {
      type: "ICE",
      x: 12,
      y: 13
    },
    {
      type: "ICE",
      x: 5,
      y: 4
    },
    {
      type: "WALL",
      x: 13,
      y: 11
    },
    {
      type: "ICE",
      x: 11,
      y: 5
    },
    {
      type: "WALL",
      x: 10,
      y: 12
    },
    {
      type: "ICE",
      x: 8,
      y: 5
    },
    {
      type: "ICE",
      x: 10,
      y: 5
    },
    {
      type: "ICE",
      x: 9,
      y: 6
    },
    {
      type: "ICE",
      x: 9,
      y: 4
    },
    {
      type: "ICE",
      x: 4,
      y: 1
    },
    {
      type: "ICE",
      x: 1,
      y: 5
    },
    {
      type: "WATER",
      x: 6,
      y: 2
    },
    {
      type: "ICE",
      x: 6,
      y: 1
    },
    {
      type: "WALL",
      x: 5,
      y: 2
    },
    {
      type: "ICE",
      x: 1,
      y: 8
    },
    {
      type: "ICE",
      x: 2,
      y: 1
    },
    {
      type: "ICE",
      x: 1,
      y: 9
    },
    {
      type: "WATER",
      x: 3,
      y: 1
    },
    {
      type: "WATER",
      x: 1,
      y: 6
    },
    {
      type: "CHIP",
      x: 11,
      y: 8
    }
  ]
};

export default data;
